import { Button, Switch, Popconfirm } from "antd";
import type { ColumnsType } from "antd/es/table";
import dayjs from 'dayjs';
import { FormConfigType } from "../../../components/editForm";
import { langPage, langCommon, langTableColumns } from "../../../locales";
import { MemberServer } from "./../../../server";
import { floatNumberInThousands } from "../../../utils/tools"

const server = MemberServer.User
const lang = langPage?.member?.user;

export const DEFAULT_QUERY_DATA = {
    Email: "",
    Type: null,
    InviteCode: "",
}

export const generateQueryFormConfig = (props: any): FormConfigType => {

    return [
        {
            title: lang?.email,
            type: "input",
            field: "Email",
            allowClear: true,
        },
        {
            title: lang?.type,
            type: "select",
            field: "Type",
            options: [
                { id: 1, name: lang?.type1 },
                { id: 10, name: lang?.type2 }
            ],
            allowClear: true,
            style: {
                width: 200
            }
        },
        {
            title: "邀请码",
            type: "input",
            field: "InviteCode",
            allowClear: true,
        },
    ];
}

const renderPrice = (val: number | string) => {
    return floatNumberInThousands(val) || ''
}


export const generateTableColumns = (props: any): ColumnsType => {
    const { operationRef, setLoading, refresh, amountRef, resetCode } = props;

    return [
        {
            title: 'Id',
            dataIndex: "Id",
        },
        {
            title: lang?.account,
            dataIndex: "Account",
        },
        {
            title: lang?.email,
            dataIndex: "Email",
        },
        {
            title: '邀请码',
            dataIndex: "Manager",
            render: (value) => {
                return value?.InviteCode
            }
        },
        {
            title: lang?.amount,
            dataIndex: "Wallets",
            render: (value) => {
                return renderPrice(value?.[0]?.Balance)
            }
        },
        // {
        //     title: lang?.commission,
        //     dataIndex: "Commission",
        //     render: renderPrice
        // },
        // {
        //     title: lang?.commissionAll,
        //     dataIndex: "CommissionAll",
        //     render: renderPrice
        // },
        {
            title: lang?.grade,
            dataIndex: "Grade",
            render: (value) => {
                return value?.Name
            }
        },
        // {
        //     title: lang?.usdAmount,
        //     dataIndex: "UsdAmount",
        //     render: renderPrice
        // },
        {
            title: lang?.type,
            dataIndex: "Type",
            render: (val) => {
                return val === 1 ? lang?.type1 : lang?.type2
            }
        },
        {
            title: lang?.isCanTrade,
            dataIndex: "IsCanTrade",
            render: (val) => {
                return val === 1 ? langCommon?.yes : langCommon?.no
            }
        },
        {
            title: langTableColumns?.lastIp,
            dataIndex: "LastIp",
        },
        {
            title: langTableColumns?.lastTime,
            dataIndex: "LastTime",
            render: (val) => {
                return val ? dayjs.unix(val).format('YYYY-MM-DD HH:mm:ss') : '-'
            }
        },
        {
            title: langCommon?.status,
            dataIndex: "Status",
            render: (_: any, row: any) => {
                return <Switch
                    checkedChildren={langCommon?.enabled}
                    unCheckedChildren={langCommon?.disable}
                    checked={row.Status === 1}
                    onChange={async (checked) => {
                        setLoading(true);
                        try {
                            await server.enabled({ IsCanTrade: row.IsCanTrade, MemberId: row.Id, Status: checked })
                            refresh();
                        } catch (error) {
                        }
                        setLoading(false);
                    }}
                />;
            }
        },
        {
            title: langTableColumns?.CreatedAtString,
            dataIndex: "CreatedAtString",
        },
        {
            title: langTableColumns?.operation,
            dataIndex: "ops",
            width: 170,
            fixed: "right",
            render: (_: any, row: any) => {
                return (
                    <div>
                        <Button size="small" type="link"
                            onClick={() => amountRef?.current?.changeVisible({ MemberId: row.Id, initAmount: Number(row.Wallets?.[0]?.Balance || 0) }, 'add')
                            }>
                            {lang?.addAmount}
                        </Button>
                        <Button size="small" type="link"
                            onClick={() => amountRef?.current?.changeVisible({ MemberId: row.Id, initAmount: Number(row.Wallets?.[0]?.Balance || 0) }, 'reduce')
                            }
                        >{lang?.reduceAmount}</Button>
                        <Button size="small" type="link" className="pdl0"
                            onClick={() => operationRef?.current?.changeVisible({
                                ...row,
                                Password: row.PasswordHash,
                                MemberId: row.Id
                            }, 'modify')}
                        >{langCommon?.modify}</Button>
                        <Popconfirm title="确认重置验证码吗?" onConfirm={() => resetCode({ MemberId: row.Id })} >
                            <Button size="small" type="link" className="pdl0 pdr0">重置验证码</Button>
                        </Popconfirm>
                    </div>
                )
            }
        }
    ]
}

export const generateOperationFormConfig = (props: any): FormConfigType | any => {
    const { mode, levelOptions } = props;
    return [
        {
            title: lang?.account,
            type: "input",
            field: "Account",
            allowClear: true,
            rules: [{
                required: true,
                message: `${langCommon?.pleaseInput} ${lang?.account}`
            }]
        },
        ...(mode === 'create' ? [
            {
                title: lang?.email,
                type: "input",
                field: "Email",
                allowClear: true,
                rules: [{
                    required: true,
                    message: `${langCommon?.pleaseInput} ${lang?.email}`
                }]
            },
        ] : []),
        {
            title: lang?.Password,
            type: "input",
            extendType: 'Password',
            field: "Password",
            allowClear: true,
            rules: [{
                required: true,
                validator: async (rule: any, value: any) => {
                    if (!value) {
                        return Promise.reject(`${langCommon?.pleaseInput} ${lang?.Password}`);
                    } else if (value.length < 6) {
                        return Promise.reject(`密码长度不能小于6位`);
                    }
                    return Promise.resolve();
                }
            }]
        },
        {
            title: lang?.isCanTrade,
            type: "select",
            field: "IsCanTrade",
            allowClear: true,
            options: [
                { id: 1, name: langCommon?.yes },
                { id: 2, name: langCommon?.no }
            ],
            rules: [{
                required: true,
                message: `${langCommon?.pleaseSelect} ${lang?.isCanTrade}`
            }]
        },
        {
            title: '用户等级',
            type: "select",
            field: "GradeId",
            allowClear: true,
            options: levelOptions,
            rules: [{
                required: true,
                message: `${langCommon?.pleaseSelect} 用户等级`
            }]
        },
        ...(mode === 'create' ? [
            {
                title: lang?.type,
                type: "select",
                field: "Type",
                allowClear: true,
                options: [
                    { id: 1, name: lang?.type1 },
                    { id: 10, name: lang?.type2 }
                ],
            }
        ] : [])
    ];
}


export const generateAmountOperationFormConfig = (props: any): FormConfigType => {
    const { mode, formData } = props;
    return [
        {
            title: `${mode === 'add' ? lang?.addAmount : lang?.reduceAmount}${lang?.amount1}`,
            type: "inputNumber",
            field: "Amount",
            min: 0,
            style: { width: 220 },
            rules: [{
                required: true,
                message: `${langCommon?.pleaseInput} ${lang?.amount1}`
            }]
        },
        {
            title: '备注',
            type: "input",
            field: "Remark",
            extendType: "TextArea",
            rows: 4,
            allowClear: true,
        },
        {
            title: '',
            type: "render",
            field: "text",
            render: () => {
                return (
                    <div className="ml20">
                        <div>{lang?.now}: <span className="ml10">{formData.initAmount || 0}</span></div>

                        <div className="mt20">
                            {lang?.after}:   {
                                formData.Amount ? <span className="ml10">
                                    {
                                        mode === 'add' ? ((formData.initAmount || 0) + (formData.Amount || 0)).toFixed(2) :
                                            ((formData.initAmount || 0) - (formData.Amount || 0)).toFixed(2)
                                    }
                                </span> : null
                            }
                        </div>
                    </div>
                )
            }
        }
    ];
}